import { useParams } from "react-router";
import { EmptyState } from "@web/components/EmptyState.tsx";
import { PlaylistExplorer } from "@web/features/library/PlaylistExplorer.tsx";
import type { ExplorePlaylistKind } from "#shared/schemas/playlistExplore.ts";

export function PlaylistExplorePage({ kind }: { kind: ExplorePlaylistKind }) {
  const { id } = useParams();
  if (!id) {
    return (
      <EmptyState
        title="Missing playlist"
        description="Open explore from a playlist in Browse or the detail sheet."
      />
    );
  }
  return <PlaylistExplorer kind={kind} id={id} />;
}
